import type { RecordsGatewayPort } from "@/application/records/ports/RecordsGatewayPort";
import type { MarkdownEndpoint } from "@/application/records/ports/RecordsGatewayPort";

export interface FetchRecordMarkdownInputDto {
  recordId: string;
  reportType: MarkdownEndpoint;
  version?: number | null;
}

export interface FetchRecordMarkdownOutputDto {
  markdown: string | null;
  version: number;
}

/**
 * Use case: загрузка markdown-отчета по записи.
 */
export class FetchRecordMarkdownUseCase {
  constructor(private readonly gateway: RecordsGatewayPort) {}

  async execute(
    input: FetchRecordMarkdownInputDto
  ): Promise<FetchRecordMarkdownOutputDto> {
    const { recordId, reportType, version = null } = input;
    const response = await this.gateway.getMarkdownReport(recordId, reportType, {
      version,
    });

    return {
      markdown: response.markdown_content ?? null,
      version: response.version,
    };
  }
}
